export default __webpack_public_path__ + "static/media/elo.0c722505.png";